import { BellRing, History, Lightbulb } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { ConnectionLines, GraphicCard, IllustrationFrame, VerifiedPill } from './shared'

/** Month by month, the sources the file received: a column per month, the latest one marked. */
const MONTHS = [36, 22, 48, 30, 58, 40, 70, 52, 84] as const

/** The theme file: its sources stacked month by month on one axis, the way the dashboard draws them. */
function FileOverTime({ label }: { label: string }) {
  return (
    <g>
      <rect
        x="56"
        y="56"
        width="196"
        height="180"
        rx="16"
        className="fill-card stroke-primary/40"
      />
      <text x="76" y="84" className="fill-foreground text-xs font-semibold">
        {label}
      </text>
      <path d="M76 204H232" className="stroke-muted-foreground/30" strokeWidth="1.5" />
      {MONTHS.map((height, index) => {
        const x = 78 + index * 17
        const latest = index === MONTHS.length - 1
        return (
          <rect
            key={x}
            x={x}
            y={204 - height}
            width="11"
            height={height}
            rx="3"
            className={latest ? 'fill-primary' : 'fill-primary/30'}
          />
        )
      })}
      <circle cx="219.5" cy="216" r="3" className="fill-primary" />
    </g>
  )
}

export function LongHorizonFileIllustration() {
  const { t } = useTranslation()
  const key = 'whatsNew.slides.longHorizonFile.graphic'
  return (
    <IllustrationFrame label={t(`${key}.description`)}>
      <ConnectionLines d="M252 146H300 M300 80V212 M300 80H433 M300 146H466 M300 212H405" />
      <FileOverTime label={t(`${key}.file`)} />
      <GraphicCard card={{ x: 433, y: 51, label: t(`${key}.alerts`), icon: BellRing }} />
      <GraphicCard card={{ x: 466, y: 116, label: t(`${key}.history`), icon: History }} />
      <GraphicCard card={{ x: 405, y: 183, label: t(`${key}.hypotheses`), icon: Lightbulb }} />
      <VerifiedPill label={t(`${key}.traceable`)} y={252} />
    </IllustrationFrame>
  )
}
